import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["phoneNumber"];
var mapBillingDetailsToStripe = function mapBillingDetailsToStripe(details) {
  var _details$email, _ref, _details$phone, _details$phoneNumber, _details$address, _details$address2;
  if (!details) return undefined;
  var email = (_details$email = details.email) !== null && _details$email !== void 0 ? _details$email : '';
  var phone = 'phone' in details ? (_ref = (_details$phone = details.phone) !== null && _details$phone !== void 0 ? _details$phone : details.phoneNumber) !== null && _ref !== void 0 ? _ref : '' : (_details$phoneNumber = details.phoneNumber) !== null && _details$phoneNumber !== void 0 ? _details$phoneNumber : '';
  if ('name' in details && (_details$address = details.address) !== null && _details$address !== void 0 && _details$address.line1 && (_details$address2 = details.address) !== null && _details$address2 !== void 0 && _details$address2.country) {
    var phoneNumber = details.phoneNumber,
      rest = _objectWithoutProperties(details, _excluded);
    return _objectSpread(_objectSpread({}, rest), {}, {
      phone: phone
    });
  }
  var _details$address3 = details.address,
    _details$address4 = _details$address3 === void 0 ? {} : _details$address3,
    _details$address4$cou = _details$address4.countryCode,
    country = _details$address4$cou === void 0 ? 'GB' : _details$address4$cou,
    _details$address4$cou2 = _details$address4.countyStateOrProvince,
    state = _details$address4$cou2 === void 0 ? '' : _details$address4$cou2,
    _details$address4$add = _details$address4.addressLine1,
    line1 = _details$address4$add === void 0 ? '' : _details$address4$add,
    _details$address4$add2 = _details$address4.addressLine2,
    line2 = _details$address4$add2 === void 0 ? '' : _details$address4$add2,
    _details$address4$pos = _details$address4.postcode,
    postal_code = _details$address4$pos === void 0 ? '' : _details$address4$pos,
    _details$address4$tow = _details$address4.townOrCity,
    city = _details$address4$tow === void 0 ? '' : _details$address4$tow,
    _details$addressee = details.addressee,
    _details$addressee2 = _details$addressee === void 0 ? {} : _details$addressee,
    _details$addressee2$f = _details$addressee2.firstName,
    firstName = _details$addressee2$f === void 0 ? '' : _details$addressee2$f,
    _details$addressee2$l = _details$addressee2.lastName,
    lastName = _details$addressee2$l === void 0 ? '' : _details$addressee2$l;
  return {
    address: {
      city: city,
      country: country,
      line1: line1,
      line2: line2,
      postal_code: postal_code,
      state: state
    },
    email: email,
    name: "".concat(firstName, " ").concat(lastName).trim(),
    phone: phone
  };
};
export { mapBillingDetailsToStripe as default };